import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'ppl-view-recon-files',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './view-recon-files.component.html',
  styleUrl: './view-recon-files.component.css'
})
export class ViewReconFilesComponent {

}
